module.exports = __webpack_public_path__ + "static/img/ionicons.621bd38.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme/fonts/ionicons.svg?v=2.0.0
// module id = aujc
// module chunks = 34